import { forwardRef } from "react";
import * as s from "./ButtonStyled";
import * as mediaQuery from "components/MediaQuery";

type TableButtonProps = {
  label: string | React.ReactNode;
  buttonType?: string;
  icon?: any;
  className?: string;
};

function TableButton({
  label,
  className = "",
  buttonType,
  icon,
  ...divProps
}: TableButtonProps &
  React.ButtonHTMLAttributes<HTMLButtonElement>, ref: React.Ref<HTMLButtonElement>): JSX.Element {
  return (
    <>
      <mediaQuery.Default>
        <s.Container
          buttonType={buttonType ? buttonType : "cancel"}
          className={`table-button ${className}`}
          {...divProps}
        >
          <s.ButtonLabel table>
            {label}
            {icon && icon}
          </s.ButtonLabel>
        </s.Container>
      </mediaQuery.Default>
      <mediaQuery.Mobile>
        <s.Container
          buttonType={buttonType ? buttonType : "cancel"}
          className="table-button"
          {...divProps}
        >
          <s.ButtonLabel table>
            {!(
              label === "Edit" ||
              label === "Enter" ||
              (typeof label === "string" && label.includes("View"))
            ) &&
              icon &&
              icon}
            {label}
          </s.ButtonLabel>
        </s.Container>
      </mediaQuery.Mobile>
    </>
  );
}

export default forwardRef(TableButton);
